<!--Tender List Section Start From Here-->
<section *ngIf="!showDiv" class="list-section" [ngClass]="{ 'stripMarginAddedListPage': stripMargin,
'subscribe-strip-margin':  shouldShowTrialBanner
}">
  <div class="container-fluid">
    <!--Navbar Start From Here-->
    <nav class="breadcrumb-section" aria-label="breadcrumb">
      <ol class="breadcrumb align-items-center">
        <li class="breadcrumb-item d-flex align-items-center">
          <a routerLink="">Home</a>
        </li>
        <li *ngFor="let bread of details?.breadCrumb; let i = index" class="breadcrumb-item d-flex align-items-center">
          <i class=" breadcrumb-arrow-right sprite-img-list "></i>

          <a *ngIf="i !== details?.breadCrumb.length - 1"
            (click)="navigate(bread?.breadCrumbLink); $event.preventDefault()"
            [href]="baseUrl + '/' + bread?.breadCrumbLink" class="btn quinary-btn">
            {{ bread?.breadCrumbName }}
          </a>
          <a *ngIf="i === details?.breadCrumb.length - 1" class="btn quinary-btn">
            {{ bread?.breadCrumbName }}
          </a>
        </li>
      </ol>
    </nav>
    <!--Navbar End Here-->
    <div class="tender-list-heading">
      <h1>{{ details?.heading }}</h1>

      <div class="description-container mb-10">
        <p class="description-text mb-0" [class.read-more]="readMore" [class.read-less]="!readMore"
          [innerHTML]="details?.description">
        </p>
        <span *ngIf="details?.description?.length > limit">
          <a class="read-more-link" href="javascript:void(0)" (click)="toggleReadMore()">
            {{ readMore ? 'Read less' : 'Read more' }}
          </a>
        </span>
      </div>
    </div>
    <div>

      <div class="horizontal-tab list-tab d-flex justify-content-between listing-card-tab" id="navTabsListHorizontal">
        <ul role="tablist" class="nav nav-tabs" aria-label="Tabs">
          <li *ngFor="let tabz of tabs" class="nav-item" role="presentation">
            <a role="tab" class="nav-link cursor" [class.active]="tabz.active"
              [attr.aria-selected]="tabz.active ? 'true' : 'false'" [attr.aria-controls]="tabz.panelId"
              [attr.id]="tabz.id" (click)="onTabSelect(tabz, tabz.title)">
              <span> {{ tabz.title | uppercase }} TENDERS ( {{ tabz?.activeTendersCount | numberFormatter }} )</span>
            </a>
          </li>
        </ul>
        <div class="paid-features-dropdown">

          <!-- Main Button Group -->
          <ng-container *ngIf="shouldShowTrialBanner || !planAccess.hasAccess('advanceFilter'); else advancedAccess">
            <button (click)="onUpgrade()" class="subscribe-download-btn me-3">
              Subscribe & Download Tender List
            </button>
          </ng-container>

          <!-- Dropdown for Advanced Access -->
          <ng-template #advancedAccess>
            <div class="tender-download-dropdown">
              <button class="tender-download-btn" (click)="toggleDropdown($event)">
                Download Tender List
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="22" height="22" fill="currentColor">
                  <path
                    d="M11.9999 13.1714L16.9497 8.22168L18.3639 9.63589L11.9999 15.9999L5.63599 9.63589L7.0502 8.22168L11.9999 13.1714Z" />
                </svg>
              </button>

              <div class="tender-download-content" [class.show]="isDropdownOpen">
                <a *ngFor="let option of tenderOptions" href="javascript:void(0)"
                  (click)="downloadTenderList(option.value)">
                  {{ option.label }}
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18"
                    fill="rgba(40,139,237,1)">
                    <path
                      d="M13 10H18L12 16L6 10H11V3H13V10ZM4 19H20V12H22V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V12H4V19Z" />
                  </svg>
                </a>
              </div>
            </div>
          </ng-template>
        </div>
      </div>

      <div>
        <div class=" d-lg-flex flex-wrap align-items-center tag-list-section mt-20">
          <ng-container>
            <div class="d-flex flex-nowrap flex-lg-wrap chips-overflow" title="testing">
              <a (click)="navigate('all-tenders/active'); $event.preventDefault()"
                [href]="baseUrl + 'all-tenders/active'" class="blue-anchor text-center mb-10 small-anchor d-lg-block">
                Reset
              </a>
              <!-- <a (click)="clearAllFilter()" class="blue-anchor text-center mb-10 small-anchor d-lg-block"
                *ngIf="appliedFilters.length > 0">Reset All</a> -->
              <ng-container *ngFor="let filter of appliedFilters; let i = index">
                <div class="fltr-chip" title="{{ filter.value }}">
                  <a (click)="removeFilter(filter, i)">
                    <span>{{ filter.value }}</span>
                    <i class="black-cross sprite-img-list"></i>
                  </a>
                </div>
              </ng-container>
            </div>
          </ng-container>
        </div>
        <!--Filter Start From Here-->
        <div class="row mt-10">
          <div class="col-lg-3 d-none d-lg-block filter-section">
            <form [formGroup]="formGroup" class="h-100" (submit)="applyFilters()">
              <div class="fltr-column">
                <!-- Sorting Section Start From Here-->
                <div class="panel-group fltr">
                  <div class="panel" [ngClass]="{'panel-open' : sortByAccordion[0]}">
                    <div class="panel card panel-default">
                      <div class="panel-heading card-header panel-enabled" (click)="SortToggle(0)">
                        <div class="panel-title">
                          <div class="accordion-toggle">
                            <button type="button" class="btn btn-link"> Sort By </button>
                          </div>
                        </div>
                      </div>
                      <div class="panel-collapse collapse" [ngClass]="{'show displayBlock' : sortByAccordion[0]}"
                        *ngIf="sortByAccordion[0]">
                        <div class="panel-body card-block card-body">
                          <div class="form-check radio-1">
                            <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1"
                              value="option1" checked
                              (click)="changeSortingValue('amount',(isSortingValAsc = !isSortingValAsc))" />
                            <label class="form-check-label" for="exampleRadios1">
                              Relevance
                            </label>
                          </div>
                          <div class="form-check radio-1">
                            <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios2"
                              value="option2" (click)="
                          changeSortingValue('startDate', true)" />
                            <label class="form-check-label" for="exampleRadios2">
                              Opening Date - Descending
                            </label>
                          </div>

                          <div class="form-check radio-1">
                            <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios3"
                              value="option3" (click)="
                          changeSortingValue('startDate', false)" />
                            <label class="form-check-label" for="exampleRadios3">
                              Opening Date - Ascending
                            </label>
                          </div>
                          <div class="form-check radio-1">
                            <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios5"
                              value="option5" (click)="
                          changeSortingValue('endDate', true)" />
                            <label class="form-check-label" for="exampleRadios5">
                              Closing Date - Descending
                            </label>
                          </div>
                          <div class="form-check radio-1">
                            <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios6"
                              value="option6" (click)="
                          changeSortingValue('endDate', false)" />
                            <label class="form-check-label" for="exampleRadios6">
                              Closing Date - Ascending
                            </label>
                          </div>
                          <div class="form-check radio-1">
                            <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios7"
                              value="option7" (click)="
                          changeSortingValue('amount', true)" />
                            <label class="form-check-label" for="exampleRadios7">
                              Tender Amount - Highest First
                            </label>
                          </div>
                          <div class="form-check radio-1">
                            <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios8"
                              value="option8" (click)="
                          changeSortingValue('amount', false)" />
                            <label class="form-check-label" for="exampleRadios8">
                              Tender Amount - Lowest First
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
                <!--Sorting Section end From Here-->

                <!--Keyword Start From Here-->
                <div *ngIf="urlTypeSegments[1] !=='keywords'" class="panel-group fltr">
                  <div class="panel" [ngClass]="{'panel-open' : otherFilterAccordion[0]}">
                    <div class="panel card panel-default">
                      <div class="panel-heading card-header panel-enabled" (click)="otherFilterToggle(0)">
                        <div class="panel-title">
                          <div class="accordion-toggle">
                            <button type="button" class="btn btn-link">Keyword</button>
                          </div>
                        </div>
                      </div>
                      <div class="panel-collapse collapse" [ngClass]="{'show displayBlock' : otherFilterAccordion[0]}"
                        *ngIf="otherFilterAccordion[0]">
                        <div class="panel-body card-block card-body">
                          <div class="input-group mb-3 icon-input">
                            <input type="text" class="form-control border-end-0" placeholder="Search Keyword"
                              [ngModelOptions]="{ standalone: true }" [(ngModel)]="keywordsFilterQuery" />
                            <span class="input-group-text">
                              <i class="input-search-icon sprite-img-list"></i>
                            </span>
                          </div>

                          <div class="filter-checkbox overflow-scroll-1">
                            <ng-container *ngFor="
                                let keywords of keywordsList
                                  | stateFilter : keywordsFilterQuery
                              ">
                              <div class="form-check checkbox-1" [title]="keywords?.name">
                                <input class="form-check-input filter-state-checkbox" [id]="keywords?.name"
                                  type="checkbox" [value]="keywords" (change)="
                                    selectItem(
                                      keywords.id,
                                      $event,
                                      keywordsList,
                                      formGroup.value.keywordsId,
                                      'keywordsId'
                                    )
                                  " (change)="changeInFilters('keywordsId', $event)" [checked]="keywords.isSelected" />
                                <label class="form-check-label" [for]="keywords?.name">
                                  {{ keywords?.name }}
                                </label>
                              </div>
                            </ng-container>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!--Keyword End From Here-->

                <!--MIN MAX Filter Start From Here-->
                <div class="panel-group fltr">
                  <div class="panel" [ngClass]="{'panel-open' : otherFilterAccordion[1]}">
                    <div class="panel card panel-default">
                      <div class="panel-heading card-header panel-enabled" (click)="otherFilterToggle(1)">
                        <div class="panel-title">
                          <div class="accordion-toggle">
                            <button type="button" class="btn btn-link"> Tender Amount </button>
                          </div>
                        </div>
                      </div>
                      <div class="panel-collapse collapse" [ngClass]="{'show displayBlock' : otherFilterAccordion[1]}"
                        *ngIf="otherFilterAccordion[1]">
                        <div class="panel-body card-block card-body">
                          <div class="row">
                            <!--MIN Filter Start From Here-->
                            <div class="col-sm-6 col-6">
                              <select name="" class="fltr-drpdown" formControlName="minAmount"
                                (change)="onAmountFilterChange()">
                                <option value="" disabled>Min</option>
                                <option>10000</option>
                                <option>20000</option>
                                <option>50000</option>
                                <option>100000</option>
                                <option>200000</option>
                                <option>500000</option>
                                <option>1000000</option>
                              </select>
                            </div>
                            <!--MIN Filter End Here-->

                            <!--MAX Filter Start From Here-->
                            <div class="col-sm-6 col-6">
                              <select name="" class="fltr-drpdown" formControlName="maxAmount"
                                (change)="onAmountFilterChange()">
                                <option value="" disabled>Max</option>
                                <option>50000</option>
                                <option>10000</option>
                                <option>200000</option>
                                <option>500000</option>
                                <option>1000000</option>
                                <option>5000000</option>
                                <option>10000000</option>
                                <option>100000000</option>
                                <option>100000000+</option>
                              </select>
                            </div>
                            <!--MAX Filter End Here-->
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!--MIN MAX Filte End Here-->

                <!-- State Start From Here-->
                <div *ngIf="urlTypeSegments[1] !=='state'" class="panel-group fltr">
                  <div class="panel" [ngClass]="{'panel-open' : otherFilterAccordion[2]}">
                    <div class="panel card panel-default">

                      <!-- Panel Header -->
                      <div class="panel-heading card-header"
                        [ngClass]="{'panel-heading-enabled': planAccess.hasAccess('advanceFilter'),'panel-heading-disabled': !planAccess.hasAccess('advanceFilter')}"
                        (click)="planAccess.hasAccess('advanceFilter') ? otherFilterToggle(2) : null">
                        <div class="panel-title d-flex justify-content-between align-items-center">
                          <div class="accordion-toggle w-100"
                            [ngClass]="{'d-flex': planAccess.hasAccess('advanceFilter'),'panel-disabled': !planAccess.hasAccess('advanceFilter')}">
                            <button type="button" class="btn btn-link d-flex justify-content-between w-100"
                              [disabled]="!planAccess.hasAccess('advanceFilter')">
                              <span> State </span>
                              <svg *ngIf="!planAccess.hasAccess('advanceFilter')" xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24" width="20" height="20" fill="rgba(217,35,45,1)">
                                <path
                                  d="M19 10H20C20.5523 10 21 10.4477 21 11V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V11C3 10.4477 3.44772 10 4 10H5V9C5 5.13401 8.13401 2 12 2C15.866 2 19 5.13401 19 9V10ZM17 10V9C17 6.23858 14.7614 4 12 4C9.23858 4 7 6.23858 7 9V10H17ZM11 14V18H13V14H11Z">
                                </path>
                              </svg>
                            </button>
                          </div>
                        </div>
                      </div>

                      <div class="panel-collapse collapse" [ngClass]="{'show displayBlock' : otherFilterAccordion[2]}"
                        *ngIf="otherFilterAccordion[2] && planAccess.hasAccess('advanceFilter')">
                        <div class="panel-body card-block card-body">
                          <div class="input-group mb-3 icon-input">
                            <input type="text" class="form-control border-end-0" placeholder="Search State"
                              [ngModelOptions]="{ standalone: true }" [(ngModel)]="stateFilterQuery" />
                            <span class="input-group-text">
                              <i class="input-search-icon sprite-img-list"></i>
                            </span>
                          </div>

                          <div class="filter-checkbox overflow-scroll-1">
                            <ng-container *ngFor="
                                let state of statesList
                                  | stateFilter : stateFilterQuery
                              ">
                              <div class="form-check checkbox-1" [title]="state?.name">
                                <input class="form-check-input filter-state-checkbox" [id]="state?.name" type="checkbox"
                                  [value]="state?.id"
                                  (change)="selectItem(state.id,$event,statesList,formGroup.value.stateId,'stateId')"
                                  (change)="changeInFilters('stateId', $event)" [checked]="state.isSelected" />
                                <label class="form-check-label" [for]="state?.name">
                                  {{ state?.name }}
                                </label>
                              </div>
                            </ng-container>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- State End Here-->

                <!-- city From Here-->
                <div *ngIf="urlTypeSegments[1] !=='city'" class="panel-group fltr">
                  <div class="panel" [ngClass]="{'panel-open' : otherFilterAccordion[3]}">
                    <div class="panel card panel-default">

                      <!-- Panel Header -->
                      <div class="panel-heading card-header"
                        [ngClass]="{'panel-heading-enabled': planAccess.hasAccess('advanceFilter'),'panel-heading-disabled': !planAccess.hasAccess('advanceFilter')}"
                        (click)="planAccess.hasAccess('advanceFilter') ? otherFilterToggle(3) : null">
                        <div class="panel-title d-flex justify-content-between align-items-center">
                          <div class="accordion-toggle w-100"
                            [ngClass]="{'d-flex': planAccess.hasAccess('advanceFilter'),'panel-disabled': !planAccess.hasAccess('advanceFilter')}">
                            <button type="button" class="btn btn-link d-flex justify-content-between w-100"
                              [disabled]="!planAccess.hasAccess('advanceFilter')">
                              <span> City </span>
                              <svg *ngIf="!planAccess.hasAccess('advanceFilter')" xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24" width="20" height="20" fill="rgba(217,35,45,1)">
                                <path
                                  d="M19 10H20C20.5523 10 21 10.4477 21 11V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V11C3 10.4477 3.44772 10 4 10H5V9C5 5.13401 8.13401 2 12 2C15.866 2 19 5.13401 19 9V10ZM17 10V9C17 6.23858 14.7614 4 12 4C9.23858 4 7 6.23858 7 9V10H17ZM11 14V18H13V14H11Z">
                                </path>
                              </svg>
                            </button>
                          </div>
                        </div>
                      </div>

                      <div class="panel-collapse collapse" [ngClass]="{'show displayBlock' : otherFilterAccordion[3]}"
                        *ngIf="otherFilterAccordion[3]">
                        <div class="panel-body card-block card-body">
                          <div class="input-group mb-3 icon-input">
                            <input type="text" class="form-control border-end-0" placeholder="Search City"
                              [ngModelOptions]="{ standalone: true }" [(ngModel)]="citiesFilterQuery" />
                            <span class="input-group-text">
                              <i class="input-search-icon sprite-img-list"></i>
                            </span>
                          </div>

                          <div class="filter-checkbox overflow-scroll-1">
                            <ng-container *ngFor="
                                let city of citiesList
                                  | stateFilter : citiesFilterQuery
                              ">
                              <div class="form-check checkbox-1" [title]="city?.name">
                                <input class="form-check-input filter-state-checkbox" [id]="city?.name" type="checkbox"
                                  [value]="city?.id"
                                  (change)="selectItem(city.id,$event,citiesList,formGroup.value.cityId,'cityId')"
                                  (change)="changeInFilters('cityId', $event)" [checked]="city.isSelected" />
                                <label class="form-check-label" [for]="city?.name">
                                  {{ city?.name }}
                                </label>
                              </div>
                            </ng-container>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- city End Here-->

                <!-- Authority From Here-->
                <div *ngIf="urlTypeSegments[1] !=='authority'" class="panel-group fltr">
                  <div class="panel" [ngClass]="{'panel-open' : otherFilterAccordion[4]}">
                    <div class="panel card panel-default">

                      <!-- Panel Header -->
                      <div class="panel-heading card-header"
                        [ngClass]="{'panel-heading-enabled': planAccess.hasAccess('advanceFilter'),'panel-heading-disabled': !planAccess.hasAccess('advanceFilter')}"
                        (click)="planAccess.hasAccess('advanceFilter') ? otherFilterToggle(4) : null">
                        <div class="panel-title d-flex justify-content-between align-items-center">
                          <div class="accordion-toggle w-100"
                            [ngClass]="{'d-flex': planAccess.hasAccess('advanceFilter'),'panel-disabled': !planAccess.hasAccess('advanceFilter')}">
                            <button type="button" class="btn btn-link d-flex justify-content-between w-100"
                              [disabled]="!planAccess.hasAccess('advanceFilter')">
                              <span> Authority </span>
                              <svg *ngIf="!planAccess.hasAccess('advanceFilter')" xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24" width="20" height="20" fill="rgba(217,35,45,1)">
                                <path
                                  d="M19 10H20C20.5523 10 21 10.4477 21 11V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V11C3 10.4477 3.44772 10 4 10H5V9C5 5.13401 8.13401 2 12 2C15.866 2 19 5.13401 19 9V10ZM17 10V9C17 6.23858 14.7614 4 12 4C9.23858 4 7 6.23858 7 9V10H17ZM11 14V18H13V14H11Z">
                                </path>
                              </svg>
                            </button>
                          </div>
                        </div>
                      </div>

                      <!-- <div class="panel-heading card-header panel-enabled" (click)="otherFilterToggle(4)">
                        <div class="panel-title">
                          <div class="accordion-toggle">
                            <button type="button" class="btn btn-link">Authority</button>
                          </div>
                        </div>
                      </div> -->

                      <div class="panel-collapse collapse" [ngClass]="{'show displayBlock' : otherFilterAccordion[4]}"
                        *ngIf="otherFilterAccordion[4]">
                        <div class="panel-body card-block card-body">
                          <div class="input-group mb-3 icon-input">
                            <input type="text" class="form-control border-end-0" placeholder="Search Authority"
                              [ngModelOptions]="{ standalone: true }" [(ngModel)]="authorityFilterQuery" />
                            <span class="input-group-text">
                              <i class="input-search-icon sprite-img-list"></i>
                            </span>
                          </div>

                          <div class="filter-checkbox overflow-scroll-1">
                            <ng-container *ngFor="let authority of authorityList| stateFilter : authorityFilterQuery">
                              <div class="form-check checkbox-1" [title]="authority?.name">
                                <input class="form-check-input filter-state-checkbox" [id]="authority?.name"
                                  type="checkbox" [value]="authority?.id"
                                  (change)="selectItem(authority.id,$event,authorityList,formGroup.value.authorityId,'authorityId')"
                                  (change)="changeInFilters('authorityId', $event)" [checked]="authority.isSelected" />
                                <label class="form-check-label" [for]="authority?.name">{{ authority?.name }}</label>
                              </div>
                            </ng-container>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Authority End Here-->

                <!-- Category From Here-->
                <div *ngIf="urlTypeSegments[1] !=='category'" class="panel-group fltr">
                  <div class="panel" [ngClass]="{'panel-open' : otherFilterAccordion[5]}">
                    <div class="panel card panel-default">

                      <!-- Panel Header -->
                      <div class="panel-heading card-header"
                        [ngClass]="{'panel-heading-enabled': planAccess.hasAccess('advanceFilter'),'panel-heading-disabled': !planAccess.hasAccess('advanceFilter')}"
                        (click)="planAccess.hasAccess('advanceFilter') ? otherFilterToggle(5) : null">
                        <div class="panel-title d-flex justify-content-between align-items-center">
                          <div class="accordion-toggle w-100"
                            [ngClass]="{'d-flex': planAccess.hasAccess('advanceFilter'),'panel-disabled': !planAccess.hasAccess('advanceFilter')}">
                            <button type="button" class="btn btn-link d-flex justify-content-between w-100"
                              [disabled]="!planAccess.hasAccess('advanceFilter')">
                              <span> Category </span>
                              <svg *ngIf="!planAccess.hasAccess('advanceFilter')" xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24" width="20" height="20" fill="rgba(217,35,45,1)">
                                <path
                                  d="M19 10H20C20.5523 10 21 10.4477 21 11V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V11C3 10.4477 3.44772 10 4 10H5V9C5 5.13401 8.13401 2 12 2C15.866 2 19 5.13401 19 9V10ZM17 10V9C17 6.23858 14.7614 4 12 4C9.23858 4 7 6.23858 7 9V10H17ZM11 14V18H13V14H11Z">
                                </path>
                              </svg>
                            </button>
                          </div>
                        </div>
                      </div>

                      <div class="panel-collapse collapse" [ngClass]="{'show displayBlock' : otherFilterAccordion[5]}"
                        *ngIf="otherFilterAccordion[5]">
                        <div class="panel-body card-block card-body">
                          <div class="input-group mb-3 icon-input">
                            <input type="text" class="form-control border-end-0" placeholder="Search Category"
                              [ngModelOptions]="{ standalone: true }" [(ngModel)]="categoryFilterQuery" />
                            <span class="input-group-text">
                              <i class="input-search-icon sprite-img-list"></i>
                            </span>
                          </div>

                          <div class="filter-checkbox overflow-scroll-1">
                            <ng-container *ngFor="let category of categoriesList| stateFilter : categoryFilterQuery">
                              <div class="form-check checkbox-1" [title]="category?.name">
                                <input class="form-check-input filter-state-checkbox" [id]="category?.name"
                                  type="checkbox" [value]="category?.id"
                                  (change)="selectItem(category.id,$event,categoriesList,formGroup.value.categoryId,'categoryId')"
                                  (change)="changeInFilters('categoryId', $event)" [checked]="category.isSelected" />
                                <label class="form-check-label" [for]="category?.name">
                                  {{ category?.name }}
                                </label>
                              </div>
                            </ng-container>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Category End Here-->

                <!-- Procurement From Here-->
                <div *ngIf="urlTypeSegments[1] !=='procurement'" class="panel-group fltr">
                  <div class="panel" [ngClass]="{'panel-open' : otherFilterAccordion[6]}">
                    <div class="panel card panel-default">
                      <!-- Panel Header -->
                      <div class="panel-heading card-header"
                        [ngClass]="{'panel-heading-enabled': planAccess.hasAccess('advanceFilter'),'panel-heading-disabled': !planAccess.hasAccess('advanceFilter')}"
                        (click)="planAccess.hasAccess('advanceFilter') ? otherFilterToggle(6) : null">
                        <div class="panel-title d-flex justify-content-between align-items-center">
                          <div class="accordion-toggle w-100"
                            [ngClass]="{'d-flex': planAccess.hasAccess('advanceFilter'),'panel-disabled': !planAccess.hasAccess('advanceFilter')}">
                            <button type="button" class="btn btn-link d-flex justify-content-between w-100"
                              [disabled]="!planAccess.hasAccess('advanceFilter')">
                              <span> Procurement </span>
                              <svg *ngIf="!planAccess.hasAccess('advanceFilter')" xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24" width="20" height="20" fill="rgba(217,35,45,1)">
                                <path
                                  d="M19 10H20C20.5523 10 21 10.4477 21 11V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V11C3 10.4477 3.44772 10 4 10H5V9C5 5.13401 8.13401 2 12 2C15.866 2 19 5.13401 19 9V10ZM17 10V9C17 6.23858 14.7614 4 12 4C9.23858 4 7 6.23858 7 9V10H17ZM11 14V18H13V14H11Z">
                                </path>
                              </svg>
                            </button>
                          </div>
                        </div>
                      </div>

                      <div class="panel-collapse collapse" [ngClass]="{'show displayBlock' : otherFilterAccordion[6]}"
                        *ngIf="otherFilterAccordion[6]">
                        <div class="panel-body card-block card-body">
                          <div class="input-group mb-3 icon-input">
                            <input type="text" class="form-control border-end-0" placeholder="Search Procurement"
                              [ngModelOptions]="{ standalone: true }" [(ngModel)]="procurementFilterQuery" />
                            <span class="input-group-text">
                              <i class="input-search-icon sprite-img-list"></i>
                            </span>
                          </div>

                          <div class="filter-checkbox overflow-scroll-1">
                            <ng-container
                              *ngFor="let procurement of procurementList| stateFilter : procurementFilterQuery">
                              <div class="form-check checkbox-1" [title]="procurement?.name">
                                <input class="form-check-input filter-state-checkbox" [id]="procurement?.name"
                                  type="checkbox" [value]="procurement?.id"
                                  (change)="selectItem(procurement.id,$event,procurementList,formGroup.value.procurementId,'procurementId')"
                                  (change)="changeInFilters('procurementId', $event)"
                                  [checked]="procurement.isSelected" />
                                <label class="form-check-label" [for]="procurement?.name">
                                  {{ procurement?.name }}
                                </label>
                              </div>
                            </ng-container>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Procurement End Here-->
                <!--Tender Start Date Filter Start Form Here-->

                <div class="panel-group fltr">
                  <div class="panel" [ngClass]="{'panel-open' : otherFilterAccordion[7]}">
                    <div class="panel card panel-default">
                      <div class="panel-heading card-header panel-enabled" (click)="otherFilterToggle(7)">
                        <div class="panel-title">
                          <div class="accordion-toggle">
                            <button type="button" class="btn btn-link">Posted On</button>
                          </div>
                        </div>
                      </div>
                      <div class="panel-collapse collapse" [ngClass]="{'show displayBlock' : otherFilterAccordion[7]}"
                        *ngIf="otherFilterAccordion[7]">
                        <div class="panel-body card-block card-body">
                          <div class="d-flex flex-wrap mb-2">
                            <ng-container *ngFor="let tag of startEndDateTags">
                              <div class="fltr-chip-2">
                                <a class="cursor" (click)="setterDatePicker('startDate', tag.value)">
                                  <span>{{ tag?.view }}</span>
                                </a>
                              </div>
                            </ng-container>
                          </div>
                          <div class="row">
                            <div class="col-sm-6 col-6">
                              <input type="date" placeholder="From" (change)="changeInFilters('startDateFrom', $event)"
                                class="form-control" formControlName="startDateFrom">
                            </div>
                            <div class="col-sm-6 col-6">
                              <input type="date" placeholder="To" (change)="changeInFilters('startDateTo', $event)"
                                class="form-control" formControlName="startDateTo">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!--Tender Start Date Filter End Here-->

                <!--Tender Close Date Start Form Here-->
                <div class="panel-group fltr">
                  <div class="panel" [ngClass]="{'panel-open' : otherFilterAccordion[8]}">
                    <div class="panel card panel-default">
                      <div class="panel-heading card-header panel-enabled" (click)="otherFilterToggle(8)">
                        <div class="panel-title">
                          <div class="accordion-toggle">
                            <button type="button" class="btn btn-link">Closing On</button>
                          </div>
                        </div>
                      </div>
                      <div class="panel-collapse collapse" [ngClass]="{'show displayBlock' : otherFilterAccordion[8]}"
                        *ngIf="otherFilterAccordion[8]">
                        <div class="panel-body card-block card-body">
                          <div class="d-flex flex-wrap mb-2">
                            <ng-container *ngFor="let tag of startEndDateTags">
                              <div class="fltr-chip-2">
                                <a class="cursor" (click)="setterDatePicker('endDate', tag.value)">
                                  <span>{{ tag?.view }}</span>
                                </a>
                              </div>
                            </ng-container>
                          </div>
                          <div class="row">
                            <div class="col-sm-6 col-6">
                              <input type="date" placeholder="From" (change)="changeInFilters('endDateFrom', $event)"
                                class="form-control" formControlName="endDateFrom">
                            </div>
                            <div class="col-sm-6 col-6">
                              <input type="date" placeholder="To" (change)="changeInFilters('endDateTo', $event)"
                                class="form-control" formControlName="endDateTo">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!--Tender Close Date End Here-->
              </div>

              <!-- blog for specific categoried or slug -->
              <div *ngIf="!isMobileCheck" class="d-none d-lg-block">
                <app-blog-slider></app-blog-slider>
              </div>
              <!-- blog Ends -->

            </form>
          </div>

          <!--- Filter mobile view Start --->
          <!----tender by filter start-->

          <div class="modal-backdrop fade" *ngIf="TenderBytemplate" [class.show]="TenderBytemplate"></div>
          <div class="modal fade" *ngIf="TenderBytemplate" [ngClass]="{'show' : TenderBytemplate}"
            [class.displayBlock]="TenderBytemplate">
            <div class="modal-dialog filter-modal">
              <div class="modal-content">

                <form [formGroup]="formGroup" class="h-100" (submit)="applyFilters()">
                  <div class="d-flex justify-content-between filter-modal-header">
                    <div class="d-flex align-items-center filter-modal-heading">
                      <i class="arrow-line-left sprite-img-list me-2" (click)="closeModal('TenderBytemplate')"></i>
                      <span>Tender By</span>
                    </div>
                    <a (click)="navigate('all-tenders/active'); $event.preventDefault()"
                      [href]="baseUrl + 'all-tenders/active'">Reset</a>
                    <!-- <a (click)="clearAllFilter()">Reset</a> -->
                  </div>

                  <div class="filter-tab tab-container">
                    <ul class="nav nav-tabs">
                      <li *ngIf="urlTypeSegments[1] !=='authority'" class="nav-item"
                        [class.active]="activeTab === 'tab1'"><a class="nav-link active"
                          (click)="selectTab('tab1', $event)">Authority</a></li>
                      <li *ngIf="urlTypeSegments[1] !=='keyword'" class="nav-item"
                        [class.active]="activeTab === 'tab2'"><a class="nav-link"
                          (click)="selectTab('tab2', $event)">Keyword</a></li>
                      <li *ngIf="urlTypeSegments[1] !=='state'" class="nav-item" [class.active]="activeTab === 'tab3'">
                        <a class="nav-link d-flex align-items-center justify-content-between"
                          (click)="planAccess.hasAccess('advanceFilter') ? selectTab('tab3', $event) : null">State
                          <svg *ngIf="!planAccess.hasAccess('advanceFilter')" xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24" width="18" height="18" fill="rgba(217,35,45,1)">
                            <path
                              d="M19 10H20C20.5523 10 21 10.4477 21 11V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V11C3 10.4477 3.44772 10 4 10H5V9C5 5.13401 8.13401 2 12 2C15.866 2 19 5.13401 19 9V10ZM17 10V9C17 6.23858 14.7614 4 12 4C9.23858 4 7 6.23858 7 9V10H17ZM11 14V18H13V14H11Z">
                            </path>
                          </svg>
                        </a>
                      </li>
                      <li class="nav-item" [class.active]="activeTab === 'tab4'"><a class="nav-link"
                          (click)="selectTab('tab4', $event)">City</a></li>
                    </ul>
                    <div class="tab-content">
                      <div class="active tab-pane" *ngIf="activeTab === 'tab1' && urlTypeSegments[1] !=='authority'">
                        <div class="input-group mb-3 icon-input">
                          <input type="text" class="form-control border-end-0" placeholder="Search Authority"
                            [ngModelOptions]="{ standalone: true }" [(ngModel)]="authorityFilterQuery" />
                          <span class="input-group-text">
                            <i class="input-search-icon sprite-img-list"></i>
                          </span>
                        </div>

                        <div class="filter-checkbox overflow-scroll-1">
                          <ng-container *ngFor="
                        let authority of authorityList
                          | stateFilter : authorityFilterQuery
                      ">
                            <div class="form-check checkbox-1" [title]="authority?.name">
                              <input class="form-check-input filter-state-checkbox" [id]="authority?.name"
                                type="checkbox" [value]="authority?.id" (change)="
                            selectItem(
                              authority.id,
                              $event,
                              authorityList,
                              formGroup.value.authorityId,
                              'authorityId'
                            )
                          " (change)="changeInFilters('authorityId', $event)" [checked]="authority.isSelected" />
                              <label class="form-check-label" [for]="authority?.name">
                                {{ authority?.name }}
                              </label>
                            </div>
                          </ng-container>
                        </div>
                      </div>

                      <div class="active tab-pane" *ngIf="activeTab === 'tab2' && urlTypeSegments[1] !=='keywords'">
                        <div class="input-group mb-3 icon-input">
                          <input type="text" class="form-control border-end-0" placeholder="Search Keyword"
                            [ngModelOptions]="{ standalone: true }" [(ngModel)]="keywordsFilterQuery" />
                          <span class="input-group-text">
                            <i class="input-search-icon sprite-img-list"></i>
                          </span>
                        </div>

                        <div class="filter-checkbox overflow-scroll-1">
                          <ng-container *ngFor="
                        let keywords of keywordsList
                          | stateFilter : keywordsFilterQuery
                      ">
                            <div class="form-check checkbox-1" [title]="keywords?.name">
                              <input class="form-check-input filter-state-checkbox" [id]="keywords?.name"
                                type="checkbox" [value]="keywords" (change)="
                            selectItem(
                              keywords.id,
                              $event,
                              keywordsList,
                              formGroup.value.keywordsId,
                              'keywordsId'
                            )
                          " (change)="changeInFilters('keywordsId', $event)" [checked]="keywords.isSelected" />
                              <label class="form-check-label" [for]="keywords?.name">
                                {{ keywords?.name }}
                              </label>
                            </div>
                          </ng-container>
                        </div>
                      </div>

                      <div class="active tab-pane" *ngIf="activeTab === 'tab3' && urlTypeSegments[1] !=='state'">
                        <div class="input-group mb-3 icon-input">
                          <input type="text" class="form-control border-end-0" placeholder="Search State"
                            [ngModelOptions]="{ standalone: true }" [(ngModel)]="stateFilterQuery" />
                          <span class="input-group-text">
                            <i class="input-search-icon sprite-img-list"></i>
                          </span>
                        </div>

                        <div class="filter-checkbox overflow-scroll-1">
                          <ng-container *ngFor="
                          let state of statesList | stateFilter : stateFilterQuery
                        ">
                            <div class="form-check checkbox-1" [title]="state?.name">
                              <input class="form-check-input filter-state-checkbox" [id]="state?.name" type="checkbox"
                                [value]="state?.id" (change)="
                              selectItem(
                                state.id,
                                $event,
                                statesList,
                                formGroup.value.stateId,
                                'stateId'
                              )
                            " (change)="changeInFilters('stateId', $event)" [checked]="state.isSelected" />
                              <label class="form-check-label" [for]="state?.name">
                                {{ state?.name }}
                              </label>
                            </div>
                          </ng-container>
                        </div>
                      </div>

                      <div class="active tab-pane" *ngIf="activeTab === 'tab4' && urlTypeSegments[1] !=='city'">
                        <div class="input-group mb-3 icon-input">
                          <input type="text" class="form-control border-end-0" placeholder="Search City"
                            [ngModelOptions]="{ standalone: true }" [(ngModel)]="citiesFilterQuery" />
                          <span class="input-group-text">
                            <i class="input-search-icon sprite-img-list"></i>
                          </span>
                        </div>

                        <div class="filter-checkbox overflow-scroll-1">
                          <ng-container *ngFor="
                            let city of citiesList | stateFilter : citiesFilterQuery
                          ">
                            <div class="form-check checkbox-1" [title]="city?.name">
                              <input class="form-check-input filter-state-checkbox" [id]="city?.name" type="checkbox"
                                [value]="city?.id" (change)="
                                selectItem(
                                  city.id,
                                  $event,
                                  citiesList,
                                  formGroup.value.cityId,
                                  'cityId'
                                )
                              " (change)="changeInFilters('cityId', $event)" [checked]="city.isSelected" />
                              <label class="form-check-label" [for]="city?.name">
                                {{ city?.name }}
                              </label>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="d-flex justify-content-between filter-fixed-btn-group d-block d-lg-none">
                    <button type="submit" class="btn btn-primary" (click)="closeModal('TenderBytemplate')">
                      Apply Filter
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>

          <!----tender by filter end-->
          <div class="modal-backdrop fade" *ngIf="FilterBytemplate" [class.show]="FilterBytemplate"></div>
          <div class="modal fade" *ngIf="FilterBytemplate" [ngClass]="{'show' : FilterBytemplate}"
            [class.displayBlock]="FilterBytemplate">
            <div class="modal-dialog filter-modal">
              <div class="modal-content">
                <form [formGroup]="formGroup" class="h-100" (submit)="applyFilters()">

                  <div class="d-flex justify-content-between filter-modal-header">
                    <div class="d-flex align-items-center filter-modal-heading">
                      <i class="arrow-line-left sprite-img-list me-2" (click)="closeModal('FilterBytemplate')"></i>
                      <span>Filter By</span>
                    </div>
                    <a (click)="clearAllFilter()">CLEAR FILTER</a>
                  </div>
                  <div class="filterBySection">
                    <div class="row mb-2">
                      <!--MIN Filter Start From Here-->
                      <div class="col-sm-12 col-12">
                        <label for="minAmount" class="form-label">Tender Amount</label>
                      </div>
                      <div class="col-sm-6 col-6">

                        <select id="minAmount" name="" class="fltr-drpdown" formControlName="minAmount"
                          (change)="onAmountFilterChange()">
                          <option value="" disabled>Min</option>
                          <option>10000</option>
                          <option>20000</option>
                          <option>50000</option>
                          <option>100000</option>
                          <option>200000</option>
                          <option>500000</option>
                          <option>1000000</option>
                        </select>
                      </div>
                      <!--MIN Filter End Here-->

                      <!--MAX Filter Start From Here-->
                      <div class="col-sm-6 col-6">

                        <select name="" class="fltr-drpdown" formControlName="maxAmount"
                          (change)="onAmountFilterChange()">
                          <option value="" disabled>Max</option>
                          <option>50000</option>
                          <option>10000</option>
                          <option>200000</option>
                          <option>500000</option>
                          <option>1000000</option>
                          <option>5000000</option>
                          <option>10000000</option>
                          <option>100000000</option>
                          <option>100000000+</option>
                        </select>
                      </div>
                      <!--MAX Filter End Here-->
                    </div>

                    <div class="row mb-2">
                      <div class="col-sm-12 col-12">
                        <label for="startDateFrom" class="form-label">Posted On</label>
                        <div class="d-flex flex-wrap mt-4 mb-4">
                          <ng-container *ngFor="let tag of startEndDateTags">
                            <div class="fltr-chip-2">
                              <a class="cursor" (click)="setterDatePicker('startDate', tag.value)">
                                <span>{{ tag?.view }}</span>
                              </a>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                      <div class="col-sm-6 col-6">
                        <input type="date" onclick="this.showPicker();this.focus()" placeholder="From"
                          (change)="changeInFilters('startDateFrom', $event)" class="form-control"
                          formControlName="startDateFrom" pattern="\d{1,2}/\d{1,2}/\d{4}" required>
                      </div>

                      <div class="col-sm-6 col-6">
                        <input type="date" onclick="this.showPicker();this.focus()" placeholder="To"
                          (change)="changeInFilters('startDateTo', $event)" class="form-control"
                          formControlName="startDateTo" pattern="\d{1,2}/\d{1,2}/\d{4}" required>
                      </div>
                    </div>

                    <div class="row mb-2">
                      <div class="col-sm-12 col-12">
                        <label for="endDateFrom" class="form-label">Closing On</label>
                        <div class="d-flex flex-wrap mt-4 mb-4">
                          <ng-container *ngFor="let tag of startEndDateTags">
                            <div class="fltr-chip-2">
                              <a class="cursor" (click)="setterDatePicker('endDate', tag.value)">
                                <span>{{ tag?.view }}</span>
                              </a>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                      <div class="col-sm-6 col-6">
                        <input type="date" onclick="this.showPicker();this.focus()" placeholder="From"
                          (change)="changeInFilters('endDateFrom', $event)" class="form-control"
                          formControlName="endDateFrom" pattern="\d{1,2}/\d{1,2}/\d{4}" required>

                      </div>

                      <div class="col-sm-6 col-6">
                        <input type="date" onclick="this.showPicker();this.focus()" placeholder="To"
                          (change)="changeInFilters('endDateTo', $event)" class="form-control"
                          formControlName="endDateTo" pattern="\d{1,2}/\d{1,2}/\d{4}" required>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex justify-content-between filter-fixed-btn-group d-block d-lg-none">
                    <button type="submit" class="btn btn-primary" (click)="closeModal('FilterBytemplate')">
                      Apply Filter
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>

          <!--- Filter mobile view End --->

          <!---- sort start---->

          <div class="modal-backdrop fade" *ngIf="SortTemplate" [class.show]="SortTemplate"></div>
          <div class="modal fade" *ngIf="SortTemplate" [ngClass]="{'show' : SortTemplate}"
            [class.displayBlock]="SortTemplate">
            <div class="modal-dialog sort-modal">
              <div class="modal-content">

                <div class="d-flex justify-content-between sorting-filter-header">
                  <div class="d-flex align-items-center ">

                    <span>Sort By</span>
                  </div>
                  <a (click)="closeModal('SortTemplate')"><i
                      class="sprite-img-header-footer black-cross-circle-fill"></i></a>
                </div>
                <ul>
                  <li>
                    <div class="form-check radio-1">
                      <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1"
                        value="option1" checked (click)="
                  changeSortingValue('amount',(isSortingValAsc = !isSortingValAsc))" />
                      <label class="form-check-label" for="exampleRadios1">
                        Relevance
                      </label>
                    </div>
                  </li>
                  <li>
                    <div class="form-check radio-1">
                      <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios2"
                        value="option2" (click)="
                  changeSortingValue('startDate', true)" />
                      <label class="form-check-label" for="exampleRadios2">
                        Opening Date - Descending
                      </label>
                    </div>
                  </li>
                  <li>
                    <div class="form-check radio-1">
                      <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios3"
                        value="option3" (click)="
                  changeSortingValue('startDate', false)" />
                      <label class="form-check-label" for="exampleRadios3">
                        Opening Date - Ascending
                      </label>
                    </div>
                  </li>
                  <li>
                    <div class="form-check radio-1">
                      <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios5"
                        value="option5" (click)="
                    changeSortingValue('endDate', true)" />
                      <label class="form-check-label" for="exampleRadios5">
                        Closing Date - Descending
                      </label>
                    </div>

                  </li>
                  <li>
                    <div class="form-check radio-1">
                      <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios6"
                        value="option6" (click)="
                  changeSortingValue('endDate', false)" />
                      <label class="form-check-label" for="exampleRadios6">
                        Closing Date - Ascending
                      </label>
                    </div>
                  </li>
                  <li>
                    <div class="form-check radio-1">
                      <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios7"
                        value="option7" (click)="
                    changeSortingValue('amount', true)" />
                      <label class="form-check-label" for="exampleRadios7">
                        Tender Amount - Highest First
                      </label>
                    </div>
                  </li>
                  <li>
                    <div class="form-check radio-1">
                      <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios8"
                        value="option8" (click)="
                    changeSortingValue('amount', false)" />
                      <label class="form-check-label" for="exampleRadios8">
                        Tender Amount - Lowest First
                      </label>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="col-lg-7">
            <app-listing-card [tenders]="tenders" [totalPage]="totalPage" [tenderPayload]="tenderPayload"
              [searchTerm]="searchTerm" [activeTendersCount]="activeTendersCount" [activePage]="activePage"
              (pageChanged)="handlePageChange($event)">
            </app-listing-card>
            <!-- blog for specific categoried or slug -->
            <div *ngIf="isMobileCheck" class="d-block d-lg-none">
              <app-blog-slider></app-blog-slider>
            </div>
            <!-- blog Ends -->
          </div>
          <!--Tender List End Here-->

          <div class="col-sm-2 ads-section">

            <app-common-side-card [TenderByKeywords]="TenderByKeywords"
              [TenderByCities]="TenderByCities"></app-common-side-card>

            <!--- Do not remove this commnet HTML --->
            <!-- <div class="credlix-ad-section">
              <img src="./assets/images/rsz_credlix_white_logo.png" alt="credlix_ad"
                class="credlix-ad-image img-fluid mb-3" loading="lazy">
              <span class="ad-heading">Get Credit Loan for your Tender Execution</span>
              <span class="ad-sub-heading">Get hassle free financing for your business</span>
              <a class="credlix-external-link" target="_blank"
                href="https://www.credlix.com/?utm_source=tendershark&utm_medium=homepage&utm_campaign=promotion">Know
                More</a>
              <a class="google-play-btn" target="_blank" href="https://bit.ly/4fPvRid"><img class="img-fluid w-100"
                  src="./assets/images/google-play-badge-logo-svgrepo-com.webp" alt="google play image"></a>
            </div>

            <div class="fltr-column single-accordion mb-15">
              <div class="panel-group fltr">
                <div class="panel" [ngClass]="{'panel-open' : TenderByKeywordsAccordion[0]}">
                  <div class="panel card panel-default">
                    <div class="panel-heading card-header panel-enabled" (click)="TenderByKeywordsToggle(0)">
                      <div class="panel-title">
                        <div class="accordion-toggle">
                          <button type="button" class="btn btn-link">Tenders By Keywords</button>
                        </div>
                      </div>
                    </div>
                    <div class="panel-collapse collapse"
                      [ngClass]="{'show displayBlock' : TenderByKeywordsAccordion[0]}"
                      *ngIf="TenderByKeywordsAccordion[0]">
                      <div class="panel-body card-block card-body">
                        <ul class="view-more-list">
                          <li *ngFor="let item of visibleTenderByKeywords">
                            <a [href]="baseUrl + '/' + (item?.link || '') + '-tenders/active'">
                              {{ item?.name }} Tenders
                            </a>
                          </li>
                        </ul>
                        <a class="read-more-cta" (click)="toggleViewTenderByKeywords()">
                          {{ showAllTenderByKeywords ? "View Less" : "View More" }}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="fltr-column single-accordion mb-15">
              <div class="panel-group fltr">
                <div class="panel" [ngClass]="{'panel-open' : tenderByCitiesAccordion[0]}">
                  <div class="panel card panel-default">
                    <div class="panel-heading card-header panel-enabled" (click)="tenderByCitiesToggle(0)">
                      <div class="panel-title">
                        <div class="accordion-toggle">
                          <button type="button" class="btn btn-link"> Tenders By Cities </button>
                        </div>
                      </div>
                    </div>
                    <div class="panel-collapse collapse" [ngClass]="{'show displayBlock' : tenderByCitiesAccordion[0]}"
                      *ngIf="tenderByCitiesAccordion[0]">
                      <div class="panel-body card-block card-body">
                        <ul class="view-more-list">
                          <li *ngFor="let item of visibleTenderByCities">

                            <a [href]="baseUrl + '/' + (item?.link || '') + '-tenders/active'">
                              {{ item?.name }} Tenders
                            </a>
                          </li>
                        </ul>
                        <a class="read-more-cta" (click)="toggleViewTenderByCities()">
                          {{ showAllTenderByCities ? "View Less" : "View More" }}
                        </a>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>

            <a class="w-100"
              href="https://supplier.moglix.com/?utm_source=tendershark&utm_medium=homepage&utm_campaign=promotion"
              target="_blank" rel="noopener noreferrer">
              <img src="./assets/images/moglix_supplier_ad_right.webp" alt="supplier_central_add"
                class="category-img img-fluid w-100" loading="lazy">
            </a> -->

          </div>
        </div>
        <!--Filter End Here-->
      </div>
    </div>

    <!--Mobile View Filter Open Button Start From Here-->
    <div class="filter-btn-mobile d-flex d-lg-none">
      <a (click)="openTenderByTemplate()">Tender By ({{ filterCount }}) </a>
      <a (click)="openFilterBytemplate()"><i class="sprite-img-list filter-icon"></i> Filter</a>
      <a (click)="openSortTemplate()"><i class="sprite-img-list sort-icon"></i> Sorting</a>
    </div>
    <!--Mobile View Filter Open Button End Here-->

    <!---FAQ Accordion start --->
    <div class="container px-0">
      <app-faq-listing-page [faqId]="faqId"></app-faq-listing-page>
    </div>
    <!---FAQ Accordion end --->
  </div>
</section>

<div *ngIf="showDiv">
  <app-keywords-list></app-keywords-list>
</div>


<app-keywords-section></app-keywords-section>
<!--Tender List Section End Here-->